

// import React from 'react';

// function Hero() {
  
//     return (
//     <section className="relative bg-img h-screen flex items-center justify-center text-center px-4 sm:px-0 bg-lime-100">
//       <div className="relative z-10">
//         <h1 className="text-4xl font-bold bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-transparent bg-clip-text animate-gradient animate-pulse">
//           Welcome to Building planning, consultancy and construction
//         </h1>
//         <p className="text-lg sm:text-xl mt-4">
//           From Plans to Reality: Excellence in Construction and Consultancy!
//         </p>
//       </div>

   

//     </section>
//   );
// }

// export default Hero;
import React from 'react';
import { Link } from 'react-router-dom';

function Hero() {
  return (
    <section 
      className="relative h-screen flex flex-col items-center justify-center text-center px-4 sm:px-0 bg-cover bg-center"
      style={{ backgroundImage: "url('./Images/IMG024.png')" }}
    >
      <div className="absolute inset-0 bg-black opacity-50"></div> {/* Overlay for readability */}
      <div className="relative z-10 max-w-2xl text-center">
        <h1 className="text-5xl sm:text-6xl font-extrabold text-white leading-tight mb-4 animate__animated animate__fadeInDown">
          Welcome to Building Planning, Consultancy, and Construction
        </h1>
        <p className="text-lg sm:text-xl text-gray-300 mb-6 animate__animated animate__fadeInUp">
          From Plans to Reality: Excellence in Construction and Consultancy!
        </p>
        <h2 className="text-md italic text-gray-400 mb-8 animate__animated animate__fadeInUp">
          Your Dream Project Starts Here
        </h2>
        <Link to="/Enq" className="inline-block px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg shadow-lg transition-transform transform hover:bg-blue-700 hover:scale-105 animate__animated animate__fadeInUp"> Get a Quote</Link>
        
      </div>
    </section>
  );
}

export default Hero;
